export const ESTABLISHMENT_DRAWER_ID = 'establishment-drawer'
